import React from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Collapse from "@material-ui/core/Collapse";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import userIcon from "../../../assets/svg/dashboard/Icon_User_White.svg";
import mentorIcon from "../../../assets/svg/dashboard/Icon_Mentor_White.svg";
import startupIcon from "../../../assets/svg/dashboard/Icon_Startup_White.svg";
import cohortIcon from "../../../assets/svg/dashboard/Icon_Cohort_White_1.svg";
import MsgIcon from "../../../assets/svg/dashboard/Icon_Message_White.svg";
import logoutIcon from "../../../assets/svg/dashboard/Icon_Logout_White.svg";
import KeyboardArrowRightRoundedIcon from "@material-ui/icons/KeyboardArrowRightRounded";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import { height } from "@mui/system";
import { PRODUCTION_MOVE_HIDDEN } from "../../common/constants/actionConstants";
import { firePopup } from "../../common/popupForProduction";
import ModalFilter2 from "../../common/modalFilter2";
const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    position: "fixed !important",
    top: 0,
    left: 0,
    height: "100vh",
    transform: "translateY(160px)",
    zIndex: 500,
    [theme.breakpoints.down("md")]: {
      transform: "translateY(80px)",
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    // width: theme.spacing(7) + 1,
    width: "80px",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  drawerPaper: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "calc(100vh - 159px)",
    paddingTop: "20px",
    backgroundColor: "#b499c7",
    overflowY: "scroll !important",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#816aaf",
      borderRadius: theme.shape.borderRadius,
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 80px)",
    },
  },
  selectedListItem: {
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "80%",
      height: "2px",
      backgroundColor: "purple",
    },
  },
}));

export default function MiniDrawer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [submenuOpen, setSubmenuOpen] = React.useState(null);
  const [selectedmainmenu, setSelectedMainmenu] = React.useState();

  const [selectedsubmenu, setSelectedSubmenu] = React.useState();
  const [modalVisibility3, setModalVisibility3] = React.useState();

  const tooltipArr = [];
  tooltipArr.push("View My Dashboard");
  tooltipArr.push("View Mentor");
  tooltipArr.push("View Startup");
  tooltipArr.push("View Cohort");
  // tooltipArr.push("View Session Recordings");
  tooltipArr.push("View Messages");

  const handleDrawerOpen = () => {
    setOpen(true);
    if (window.innerWidth < 900) {
      setTimeout(() => {
        setOpen(false);
        setSubmenuOpen(null);
      }, 3000);
    }
  };

  const handleDrawerClose = () => {
    if (window.width < 900) return;
    setOpen(false);
    setSubmenuOpen(null);
  };
  const handleShow3 = () => {
    // setIsModalShown(true);
    setModalVisibility3(true);
  };
  return (
    <Drawer
      variant="permanent"
      open={true}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: clsx(classes.drawerPaper, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
      onMouseEnter={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
    >
         {modalVisibility3 && (
        <ModalFilter2
          modalVisibility={modalVisibility3}
          setModalVisibility={setModalVisibility3}
          // sendToParent={setIsParentData}
          showPurposeOfMentorship={true}
          fromPage={"mentorDashboard"}
          allCalendarData={false}
          showCohortsOnly={true}
        />
      )}
      <List>
        {
          // [
          //   { title: "My Dashboard", logo: userIcon, menuName: "adminMenu" },
          //   { title: "Mentor", logo: mentorIcon, menuName: "mentorMenu" },
          //   {
          //     title: "Startup",
          //     logo: startupIcon,
          //     submenu: ["Submenu1", "Submenu2"],
          //   },
          //   {
          //     title: "Cohort",
          //     logo: cohortIcon,
          //     submenu: ["Submenu1", "Submenu2"],
          //   },
          //   { title: "Messages", logo: MsgIcon, menuName: 'mentorMatchList' },
          // ]
          [
            {
              title: "My Dashboard",
              logo: userIcon,
              menuName: "adminMenu",
              newmenu: "adminMenu",
              submenu: [
                {
                  title: " Activity Summary",
                  menuName: "activitySummary",
                },
                {
                  title: "All Mentorships",
                  menuName: "startupMentorAllMentorships",
                },
                // {
                //   title: "Activity Summary2",
                //   menuName: "activitySummary2",
                // },
                // {
                //   title: "Activity Summary3",
                //   menuName: "activitySummary3",
                // },
                // {
                //   title: "Activity Summary4",
                //   menuName: "activitySummary4",
                // },
              ],
            },
            {
              title: "Mentor",
              logo: mentorIcon,
              // menuName: "mentorMenu",
              newmenu: "mentorMenu",
              submenu: [
                {
                  title: "Mentor Applications",
                  menuName: "mentorMenu",
                },
                {
                  title: "Mentor Requests",
                  menuName: "mentorRequests",
                },
                {
                  title: "Mentor List",
                  menuName: "allMentorList",
                },
                {
                  title: "All Mentorships",
                  menuName: "allMentorsMentorship",
                },
              ],
            },
            {
              title: "Startup",
              logo: startupIcon,
              // menuName: "startupSubmittedApplications",
              newmenu: "startupMenu",
              //"startUpApplications",
              // submenu: ["Startup Application", "Submenu2"],
              submenu: [
                {
                  title: "Startup Applications",
                  menuName: "startupSubmittedApplications",
                },
                {
                  title: "Startup Requests",
                  menuName: "startUpApplications",
                },
                {
                  title: "Startup List",
                  menuName: "allStartupList",
                },
                {
                  title: "All Mentorships",
                  menuName: "allMentorships",
                },
              ],
            },
            {
              title: "Cohort",
              logo: cohortIcon,
              newmenu: "cohortMenu",
              // menuName: "cohortApplication",
              submenu: [
               
                // {
                //   title: "Cohort Application",
                //   menuName: "cohortApplication",
                // },
                {
                  title: "Cohort Applications",
                  menuName: "MyCohortMentorDashboard",
                },
                {
                  title: "All Cohorts",
                  menuName: "cohortProgram",
                },
                {
                  title: "Cohort Sessions",
                  menuName: "cohortSessionsCalendar",
                  subMenuName: "sessionsCalendar",
                },
                {
                  title: " Cohort Group Session",
                  menuName: "CohortGroupSession",
                },
                //  {
                //    title: " Cohort Session List",
                //    menuName: "CohortSessionList",
                //  },
              ],
              // submenu: ["Submenu1", "Submenu2"],
            },
            // {
            //   title: "Session Recordings",
            //   logo: MsgIcon,
            //   menuName: "sessionRecording",
            //   newmenu: "sessionRecording",
            // },
            {
              title: "Messages",
              logo: MsgIcon,
              menuName: "adminMessage",
              newmenu: "adminMessage",
            },
          ].map((item, index) => (
            <>
              <ListItem
                button
                onClick={() => {
                  setSelectedSubmenu(
                    item.newmenu != "cohortMenu" ||
                      item.newmenu != "startupMenu" ||
                      item.newmenu != "mentorMenu"
                      ? selectedsubmenu
                      : ""
                  );

                  setSelectedMainmenu(
                    // item.newmenu != "cohortMenu" ? "" : item.newmenu
                    item.newmenu
                  );
                  if (window.innerWidth < 900) handleDrawerOpen();
                  item.menuName && item.menuName !== "cohortSessionsCalendar" && props.setSelectedMenu(item.menuName);
                  if (parseInt(submenuOpen) === index) {
                    setSubmenuOpen(-1);
                  } else {
                    setSubmenuOpen(index);
                  }
                }}
                className={
                  props.selectedMenu === item.menuName &&
                  classes.selectedListItem
                }
                key={item.title}
                style={{
                  position: "relative",
                  backgroundColor:
                    selectedmainmenu === item.newmenu ? "#5f50836b" : null,
                }}
              >
                <ListItemIcon>
                  <div className="newuserTooltip">
                    <img
                      style={
                        index > 2
                          ? { height: "44px", width: "43px", marginLeft: "5px" }
                          : index == 2
                          ? {
                              height: "55px",
                              width: "60px",
                              marginLeft: "-2px",
                            }
                          : { height: "55px", width: "55px" }
                      }
                      src={item.logo}
                      alt={item.title}
                    />
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ top: "44px", left: "109px", width: "auto" }}
                    >
                      {tooltipArr[index]}
                    </span>
                  </div>
                </ListItemIcon>
                <div className="newuserTooltip">
                  <ListItemText
                    style={{ marginLeft: "20px", color: "#fff" }}
                    primary={item.title}
                  />
                  <span
                    className="tooltiptext  tooltip-bottom"
                    style={{ top: "30px", left: "70px", width: "auto" }}
                  >
                    {tooltipArr[index]}
                  </span>
                </div>
                {item.submenu &&
                  (submenuOpen === index ? (
                    <KeyboardArrowDownRoundedIcon style={{ color: "#fff" }} />
                  ) : (
                    <KeyboardArrowRightRoundedIcon style={{ color: "#fff" }} />
                  ))}
              </ListItem>
              {item.submenu &&
                item.submenu.length > 0 &&
                item.submenu.map((subitem) => (
                  <Collapse
                    in={submenuOpen === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List
                      component="div"
                      disablePadding
                      style={{
                        paddingLeft: "50px",
                        backgroundColor: "rgba(255,255,255,0.2)",
                      }}
                    >
                      <ListItem
                        button
                        onClick={() => {
                          if (
                            subitem.menuName == "activitySummary" ||
                            subitem.menuName == "startupMentorAllMentorships" ||
                            subitem.menuName == "allMentorsMentorship" ||
                            subitem.menuName == "allMentorships"
                          ) {
                            if (PRODUCTION_MOVE_HIDDEN) {
                              firePopup();
                              return;
                            }
                          }
                          subitem.menuName &&
                          subitem.menuName !== "cohortSessionsCalendar" &&
                            props.setSelectedMenu(subitem.menuName);
                            if (subitem.menuName === "cohortSessionsCalendar") {
                              handleShow3();
                            }
                          setSelectedSubmenu(subitem.menuName);
                        }}
                        style={{
                          backgroundColor:
                            subitem.menuName === selectedsubmenu
                              ? "#8779a86b"
                              : "auto",
                        }}
                      >
                        <ListItemText
                          style={{ color: "#fff" }}
                          primary={subitem.title}
                        />
                      </ListItem>
                    </List>
                  </Collapse>
                ))}
              {/* {item.submenu && item.submenu.length > 0 && item.submenu.map(subitem => (
              <Collapse in={submenuOpen === index} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{paddingLeft: '50px', backgroundColor: 'rgba(255,255,255,0.2)'}}>
                  <ListItem button >
                    <ListItemText style={{color: '#fff'}} primary={subitem} />
                  </ListItem>
                </List>
              </Collapse>
            ))} */}
            </>
          ))
        }
        <ListItem button onClick={() => props.logoutClick()}>
          <ListItemIcon>
            <div className="newuserTooltip">
              <img
                style={{ height: "37px", width: "37px", marginLeft: "5px" }}
                src={logoutIcon}
                alt="logout"
              />
              <span
                className="tooltiptext  tooltip-bottom"
                style={{ top: "44px", left: "130px", width: "70px" }}
              >
                Logout
              </span>
            </div>
          </ListItemIcon>
          <div className="newuserTooltip">
            <ListItemText
              style={{ marginLeft: "20px", color: "#fff" }}
              primary={"Logout"}
            />
            <span
              className="tooltiptext  tooltip-bottom"
              style={{ top: "40px", left: "80px", width: "auto" }}
            >
              Logout
            </span>
          </div>
        </ListItem>
      </List>
    </Drawer>
  );
}
